import React from "react";

const Bookmark = (props) => {
  //   return <div>{JSON.stringify(props, null, 2)}</div>;
  return (
    <>
      <a
        target="_blank"
        className="bookmark-card-container"
        href={props.cardInfo.data.metadata.url}
      >
        <div className="bookmark-content">
          {props.cardInfo?.data?.metadata?.title && (
            <h2 className="bookmark-title">
              {props.cardInfo.data.metadata.title}
            </h2>
          )}
          {props.cardInfo?.data?.metadata?.description && (
            <p className="bookmark-description">
              {props.cardInfo.data.metadata.description}
            </p>
          )}
          <div className="bookmark-metadata">
            {props.cardInfo?.data?.metadata?.icon && (
              <div className="bookmark-icon text-gray-500">
                <img
                  onError={(e: any) =>
                    (e.target.src =
                      "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%23a0aec0'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9' /%3E%3C/svg%3E")
                  }
                  src={props.cardInfo.data.metadata.icon}
                  alt=""
                />
              </div>
            )}
            {props.cardInfo?.data?.metadata?.author && (
              <span className="bookmark-author">
                {props.cardInfo.data.metadata.author}
              </span>
            )}
            {props.cardInfo?.data?.metadata?.author &&
              props.cardInfo?.data?.metadata?.publisher && (
                <span className="mx-2">{" • "}</span>
              )}
            {props.cardInfo?.data?.metadata?.publisher && (
              <span className="bookmark-author">
                {props.cardInfo.data.metadata.publisher}
              </span>
            )}
          </div>
        </div>
        {props?.cardInfo?.data?.metadata?.thumbnail && (
          <div
            style={{ minWidth: "33.3%" }}
            className="bookmark-thumbnail flex-grow"
          >
            <img
              style={{ marginBottom: 0 }}
              src={props.cardInfo.data.metadata.thumbnail}
              onError={(e: any) => {
                e.target.src =
                  "data:image/png;base64,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";
              }}
              alt=""
            />
          </div>
        )}
      </a>
    </>
  );
};

export default Bookmark;
